export const visit = (vm, at) => {
at({ "en": { "reporting-enablement": null } });
};